import * as React from 'react';
import FrameWorkRenderer from './FrameWorkRenderers';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { styles } from './SummaryTable.styles';
import { Manager, Target, Popper } from 'react-popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Portal from '@material-ui/core/Portal';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { useLongPress, useSinglePress } from 'utils/hooks';
const DEFAULT_DECIMAL_PLACES = 2;

const numberWithCommas = (num: number) => {
    return !isNaN(num) &&
        num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const handleFloats = (num: any, property: any) => {
    return !isNaN(num) &&
        parseFloat(num)
            .toFixed(
                (property.valueRenderer && !isNaN(property.valueRenderer.floatingPoints) && property.valueRenderer.floatingPoints) ||
                DEFAULT_DECIMAL_PLACES);
};

const Value = ({ index, i, property, valueRenderer, itemData, classes, value, fieldSchema }) => {
    const hasMenu = valueRenderer?.hyperLink?.menu;
    const hyperlinkPresent = isHyperlinkPresent({ property, valueRenderer, itemData });

    const shouldApplyLinkClass = hasMenu || hyperlinkPresent;

    const className = classNames(
        classes.value,
        shouldApplyLinkClass && classes.link
    );

    if (fieldSchema?.CustomComponent) {
        const CustomComponent = fieldSchema.CustomComponent;

        return (<CustomComponent />);
    }

    return (
        <div key={`wrapper${index}${i} `} className={classes.splitCellContent}>
            {property.fieldNames.map((field, j) =>
                <div key={`fieldWrapper${index}${i}${j} `}>
                    {valueRenderer.preSymbol || ''}
                    {(property.frameWorkRenderers
                        && property.frameWorkRenderers[field]
                        && <FrameWorkRenderer key={`frameworkComponent${index}${i}${j} `} type={property.frameWorkRenderers[field]} value={value[field]} />)
                        || <span key={`field${index}${i}${j} `} className={className}>
                            {itemData
                                && (
                                    (
                                        valueRenderer.floatingNumber
                                        && handleFloats(itemData[field], property)
                                        ||
                                        valueRenderer.commaSeparated
                                        && numberWithCommas(itemData[field])
                                    )
                                    || itemData[field]
                                )}
                        </span>
                    }
                    {valueRenderer.postSymbol || ''}
                </div>
            )}
        </div>
    );
};

const isHyperlinkPresent = ({ valueRenderer, itemData, property }) => {
    return valueRenderer?.hyperLink?.link
        && (itemData[`${property?.fieldNames?.[0]}Url`] || itemData[`${property?.fieldNames?.[0]}Hyperlink`]);
};

const HyperLink = ({ property, itemData, valueRenderer, children }) => {
    return (
        <div
            onClick={() => {
                const fieldName = property?.fieldNames[0];
                window.open(itemData[`${fieldName}Url`] || itemData[`${fieldName}Hyperlink`]);
            }}
            title={`Click to open ${valueRenderer?.pageName || ''} in a new tab`}>
            {children}
        </div >
    );
};

const CellValue = (props) => {
    const { classes, actionList } = props;
    const [openMenu, setOpenMenu] = React.useState(false);
    const [longPress, setLongPress] = React.useState(false);

    const { onMouseDown, onMouseUp, onTouchStart, onTouchEnd } = useLongPress(
        () => {
            setLongPress(true);
            setOpenMenu(true);
        },
        () => setLongPress(false)
    );

    const { onMouseUp: handleSinglePress } = useSinglePress(() => {

        if (!longPress) {
            actionList?.[0]?.action(actionList?.[0]?.actionParam || '');
        }
    });

    const handleMouseUp = (event) => {
        handleSinglePress(event);
        onMouseUp(event);
    };

    const handleContextMenu = (event) => {
        event.preventDefault();
        setLongPress(true);
        setOpenMenu(true);
    };

    const handleClose = () => {
        setOpenMenu(false);
        setLongPress(false);
    };

    const infoIconAction = (item: any) => () => item.action(item.actionParam || '');

    if (props?.valueRenderer?.hyperLink?.menu) {
        return (
            <Manager>
                <Target>
                    <ClickAwayListener onClickAway={handleClose}>
                        <div
                            className={classes.hyperlinkedContent}
                            onMouseDown={onMouseDown}
                            onMouseUp={handleMouseUp}
                            onTouchStart={onTouchStart}
                            onTouchEnd={onTouchEnd}
                            onContextMenu={handleContextMenu}
                        >
                            <Value {...props} />
                        </div>
                    </ClickAwayListener>
                </Target>
                <Portal>
                    <Popper
                        placement='bottom-start'
                        eventsEnabled={openMenu}
                        className={classNames({ [classes.popperClose]: !openMenu })}
                    >
                        <Collapse in={openMenu} >
                            <Paper style={{ margin: 3, backgroundColor: '#eeeeee' }}>
                                <MenuList role='menu'>
                                    {
                                        actionList &&
                                        actionList.map((item: { id: string | undefined; label: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined }, index: React.Key | undefined) => (
                                            <MenuItem key={index} id={item.id} onClick={infoIconAction(item)}>
                                                {item.label}
                                            </MenuItem>
                                        ))}
                                </MenuList>
                            </Paper>
                        </Collapse>
                    </Popper>
                </Portal>
            </Manager>
        );
    }

    if (isHyperlinkPresent(props)) return (<HyperLink {...props}><Value {...props} /></HyperLink>);

    return (<Value {...props} />);
};

export default withStyles(styles, { index: 1 })(CellValue);
